import type { ChatAttachmentKind } from "@/types/(my-space)/chat.interface";

export type FileTone = "primary" | "accent" | "danger" | "warning" | "info" | "success";

/** A file's type as the colour people already associate with it — mirrors the app. */
export const fileBadge = (
  fileName: string,
  kind?: ChatAttachmentKind | string,
): { label: string; tone: FileTone } => {
  const dot = fileName.lastIndexOf(".");
  const ext = dot > 0 ? fileName.slice(dot + 1).toLowerCase() : "";
  const tone: FileTone = (() => {
    switch (ext) {
      case "pdf":
        return "danger";
      case "zip":
      case "rar":
      case "7z":
      case "gz":
      case "tar":
      case "ppt":
      case "pptx":
      case "key":
        return "warning";
      case "doc":
      case "docx":
      case "rtf":
      case "txt":
      case "pages":
        return "info";
      case "xls":
      case "xlsx":
      case "csv":
      case "numbers":
        return "success";
    }
    if (kind === "image" || kind === "video") return "accent";
    if (kind === "audio") return "info";
    return "primary";
  })();
  return { label: ext ? ext.slice(0, 4).toUpperCase() : "FILE", tone };
};
